import styled from 'styled-components'
import { v } from '../../styles/variables'

export const SLayout = styled.div`
	display: grid;
`

export const SSecondaryLayout = styled.div`
	position: absolute;
	top: 62px;
	height: calc(100% - 62px);
	display: flex;
	width: 100vw;
`

export const SMain = styled.main`
	padding: ${v.xlSpacing} calc(${v.xlSpacing} * 1.5);
	@media (max-width: 768px) {
		padding: ${v.mdSpacing};
	}
	position: relative;
	width: 100%;
	overflow-y: auto;
	z-index: 0;
	margin-left: 8px;
`
